import { BrochureTemplateId } from '../constants';

const generateBrochureLink = (brochureId, travelAgency, templateId) => {
  if (!brochureId || !travelAgency?.agencyAliasName) {
    return null;
  }

  const alias = travelAgency.agencyAliasName;
  const path = `/${alias}/brochure`;
  const url = new URL(path, window.location.origin);
  url.searchParams.set('id', brochureId);

  if (templateId === BrochureTemplateId.PAPER)
    url.searchParams.set('templateId', BrochureTemplateId.PAPER);

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('test') === 'true') url.searchParams.set('test', 'true');

  return url.toString();
};

export default generateBrochureLink;
